module.exports = __webpack_public_path__ + "img/visa@2x.6ffdbcca.png";